import React, { useState } from 'react';
import TextToSpeech from './components/TextToSpeech';

const App = () => {
    return (
      <TextToSpeech />
      // <div class="text-center card p-3">
      //   <p><strong>Convert Your Text to Speech for Free!</strong><br />Looking for a fast and easy way to turn your text into speech? Try the <strong>Unlimited Free Text to Speech Online</strong> tool! It's free, unlimited, and simple to use for creating high-quality voiceovers.<br /><strong>Click below to start converting your text to speech now!</strong></p>
      //   <p><a href="https://www.unminifydev.com/text-to-speech/" rel="noopener"><strong>Start Now!</strong></a></p>
      //   <p>
      //   <iframe src="https://unminifydev.com/humix/video/FFzQV07jQYu" width="100%" height="1000" frameborder="0" allowfullscreen></iframe>
      //   </p>
      // </div>
    );
};

export default App;
